import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AngularResizedEventModule } from 'angular-resize-event';
import { ScrollbarDirective } from './scrollbar.directive';
import { ScrollbarComponent } from './scrollbar.component';
import { DirectivesModule } from '../../directives/directives.module';

@NgModule({
  declarations: [ScrollbarComponent, ScrollbarDirective],
  exports: [ScrollbarComponent, ScrollbarDirective],
  entryComponents: [ScrollbarComponent],
  imports: [CommonModule, AngularResizedEventModule, DirectivesModule]
})
export class ScrollbarModule {}

export { ScrollbarComponent, ScrollbarDirective };
